import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { REF_VALUE } from 'src/constants'

import {
  COMPANY_REFERENCE_GET_POST,
  COMPANY_REFERENCE_ORDER_PATCH,
  COMPANY_REFERENCE_PATCH
} from './constants'

const REFERENCE_ERROR_FIELDS_MAP = { [REF_VALUE]: 'Reference' }

export const getCompanyReferences = async (config: any = {}) => {
  const { params = {}, query = {} } = config

  try {
    const response = await httpClient.request({
      method: 'get',
      url: {
        pathname: COMPANY_REFERENCE_GET_POST,
        params,
        query
      }
    })

    return response
  } catch (err: any) {
    catchError(err)

    return { items: [], meta: {} }
  }
}

export const saveCompanyReference = async (config: any = {}) => {
  const { payload = {} } = config

  try {
    await httpClient.request({
      method: 'post',
      url: {
        pathname: COMPANY_REFERENCE_GET_POST
      },
      payload
    })

    return true
  } catch (err: any) {
    catchError(err, { errorFieldsMap: REFERENCE_ERROR_FIELDS_MAP })

    return false
  }
}

export const updateCompanyReference = async (config: any = {}) => {
  const { params = {}, payload = {} } = config

  try {
    await httpClient.request({
      method: 'patch',
      url: {
        pathname: COMPANY_REFERENCE_PATCH,
        params
      },
      payload
    })

    return true
  } catch (err: any) {
    catchError(err, { errorFieldsMap: REFERENCE_ERROR_FIELDS_MAP })

    return false
  }
}

export const updateCompanyReferenceOrder = async (config: any = {}) => {
  const { payload = {} } = config

  try {
    return await httpClient.request({
      method: 'patch',
      url: {
        pathname: COMPANY_REFERENCE_ORDER_PATCH
      },
      payload
    })
  } catch (err: any) {
    catchError(err)

    return []
  }
}
